/*
 *
 * Api actions
 *
 */

import { EXECUTE_CONFIG_COMMANDS, GET_MY, LOGOUT } from '../../containers/App/constants';
import {
  ACCEPT_TERMS_AND_CONDITIONS,
  ADD_WORK,
  API_ERROR,
  API_KEY_INVALID,
  CONFIG,
  DISABLE_SESSION,
  ME,
  MY_TAGS,
  REDUCE_WORK,
  REFRESH_TOKEN,
  SET_GATE,
  WARNING,
} from './constants';

/* eslint-disable-next-line camelcase */
export function API_keyInvalid() {
  return {
    type: API_KEY_INVALID,
  };
}

export function checkSession() {
  return {
    type: REFRESH_TOKEN,
  };
}

export function disableSession() {
  return {
    type: DISABLE_SESSION,
  };
}

export function unAuth() {
  return {};
}

// export function API_callResult(baseAction, result) {
//   return {
//     type: API_CALL_RESULT,
//     baseAction,
//     result,
//   };
// }

export function setGate(id, data) {
  return {
    type: SET_GATE,
    id,
    data,
  };
}

export function addWork(id, data) {
  return {
    type: ADD_WORK,
    id,
    data,
  };
}

export function reduceWork(id, data) {
  return {
    type: REDUCE_WORK,
    id,
    data,
  };
}

export function getConfig() {
  return {
    type: GET_MY,
    work: CONFIG,
    id: CONFIG,
    path: 'public/config',
    putOnComplete: [executeConfigCommands()],
  };
}

export function executeConfigCommands() {
  return {
    type: EXECUTE_CONFIG_COMMANDS,
  };
}

export function addApiError(id, data) {
  return {
    type: API_ERROR,
    action: 'set',
    id,
    data,
  };
}

export function removeApiError(id, data) {
  return {
    type: API_ERROR,
    action: 'unset',
    id,
    data,
  };
}

export function developmentRequest(path, data, callback) {
  return {
    type: GET_MY,
    path,
    data,
    callback,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function acceptTermsAndConditions() {
  return {
    type: GET_MY,
    work: ACCEPT_TERMS_AND_CONDITIONS,
    id: ACCEPT_TERMS_AND_CONDITIONS,
    path: `accept-terms-and-conditions`,
  };
}

export function fetchMyTags() {
  return {
    type: GET_MY,
    path: 'tags',
    id: MY_TAGS,
  };
}

export function fetchMe() {
  return {
    type: GET_MY,
    path: 'customer/me',
    id: ME,
    gate: ME,
    work: ME,
  };
}

export function hideWarning(data) {
  return {
    type: WARNING,
    action: 'unset',
    data,
  };
}
